mutation RemoveEditableGroupValues($editableGroupValueIds: [ID]!) {
    removeEditableGroupValues(editableGroupValueIds: $editableGroupValueIds)
}
